package ui.settings.components

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import com.essntl.features.profile.domain.model.ProfileModel
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import navigation.settings.SettingsState
import ui.settings.SettingsNavItem
import ui.settings.getSettingsNavSidebarItems

@Composable
fun SettingsNavBar(
    state: SettingsState,
    selectedItem: SettingsNavItem,
    onItemSelected: (SettingsNavItem) -> Unit,
) {
    val currentUserRole = state.getProfile.data?.role

    val entries = remember(currentUserRole) {
        if (currentUserRole == ProfileModel.Role.Admin || currentUserRole == ProfileModel.Role.Owner)
            getSettingsNavSidebarItems()
        else
            getSettingsNavSidebarItems()
                .filter {
                    it == SettingsNavItem.DateTime ||
                        it == SettingsNavItem.ImageGallery ||
                        it == SettingsNavItem.Backoffice
                }
    }

    val lazyListState = rememberLazyListState()

    Column(
        verticalArrangement = Arrangement.spacedBy(.5.spacing),
        modifier = Modifier
            .width(230.dp)
            .fillMaxHeight()
            .clip(RoundedCornerShape(EsConstants.SectionBorderRadius))
            .background(MaterialTheme.esColorScheme.bgSecondary)
            .padding(
                vertical = EsConstants.SectionVerticalPadding,
                horizontal = EsConstants.SectionHorizontalPadding,
            ),
    ) {
        Text(
            text = "Settings",
            textAlign = TextAlign.Start,
            style = MaterialTheme.esTypography.p2Medium14.copy(
                color = with(MaterialTheme.esColorScheme) { textTertiary },
            ),
            modifier = Modifier
                .fillMaxWidth()
                .padding(
                    vertical = 4.dp,
                    horizontal = 16.dp,
                ),
        )

        LazyColumn(
            state = lazyListState,
            contentPadding = PaddingValues(start = 1.spacing),
            modifier = Modifier.fillMaxSize(),
        ) {
            item {
                Spacer(modifier = Modifier.height(.5f.spacing))
            }

            items(entries) { item ->
                Text(
                    text = item.title,
                    textAlign = TextAlign.Start,
                    style = MaterialTheme.esTypography.p1Medium16.copy(
                        color = with(MaterialTheme.esColorScheme) {
                            if (selectedItem == item) primary
                            else textSecondary
                        },
                    ),
                    modifier = Modifier
                        .fillMaxWidth()
                        .clip(RoundedCornerShape(8.dp))
                        .clickable(
                            enabled = selectedItem != item,
                        ) {
                            onItemSelected(item)
                        }
                        .background(
                            color = if (selectedItem == item)
                                MaterialTheme.esColorScheme.tinted else
                                Color.Transparent,
                            shape = RoundedCornerShape(8.dp),
                        )
                        .padding(vertical = 4.dp, horizontal = 16.dp),
                )

                Spacer(modifier = Modifier.height(2.spacing))
            }
        }
    }
}
